import { BudgetResetTypeValues } from 'src/components/oneCorp/features/MealCredit/common/formFields/Select/BudgetResetTypeSelect/BudgetResetTypeSelect.utils';
import { MealCreditLength } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { getSingularOrPlural } from 'src/utilities/getSingularOrPlural';
import { MealCreditInfoTextProps } from 'src/components/oneCorp/features/MealCredit/utils/constructMealCreditInfoText.utils';

export function getAvailabilityTextForOneTimeUseCases(
  props: Pick<
    MealCreditInfoTextProps,
    | 'budgetResetPeriod'
    | 'isDailyLengthBudget'
    | 'isWeeklyLengthBudget'
    | 'isMonthlyLengthBudget'
    | 'budgetLength'
    | 'budgetResetType'
  >
): string {
  const {
    budgetResetPeriod,
    isDailyLengthBudget,
    isWeeklyLengthBudget,
    isMonthlyLengthBudget,
    budgetLength,
    budgetResetType,
  } = props;
  const oneTimeText = 'One-time credit for';

  const isCustomDaysLengthBudget =
    budgetLength === MealCreditLength.CUSTOM &&
    budgetResetType === BudgetResetTypeValues.DAYS;

  const isCustomWeeksLengthBudget =
    budgetLength === MealCreditLength.CUSTOM &&
    budgetResetType === BudgetResetTypeValues.WEEKS;

  const isCustomMonthsLengthBudget =
    budgetLength === MealCreditLength.CUSTOM &&
    budgetResetType === BudgetResetTypeValues.MONTHS;

  if (isDailyLengthBudget) {
    return `${oneTimeText} 1 day`;
  }

  if (isCustomDaysLengthBudget) {
    return `${oneTimeText} ${budgetResetPeriod} ${getSingularOrPlural(
      budgetResetPeriod,
      'day'
    )}`;
  }

  if (isCustomWeeksLengthBudget) {
    return `${oneTimeText} ${budgetResetPeriod} ${getSingularOrPlural(
      budgetResetPeriod,
      'week'
    )}`;
  }

  if (isCustomMonthsLengthBudget) {
    return `${oneTimeText} ${budgetResetPeriod} ${getSingularOrPlural(
      budgetResetPeriod,
      'month'
    )}`;
  }

  if (isWeeklyLengthBudget) {
    return `${oneTimeText} 1 week`;
  }

  if (isMonthlyLengthBudget) {
    return `${oneTimeText} 1 month`;
  }

  return '';
}
